import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { IDynamicElement } from '../../_shared/models/dynamic/dynamic-element.model';
import { IHeroSlider } from '../../_shared/models/hero/hero-slider.model';
import { IHeroOld } from '../../_shared/models/hero/hero-old.model';
import { SliderComponent } from '../../slider/slider.component';
import { HeroOldComponent } from '../hero-old.component';


@Component({
    selector: 'sirius-hero-slider',
    templateUrl: './hero-slider.component.html',
    styleUrls: ['./hero-slider.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [SliderComponent, HeroOldComponent]
})
export class HeroSliderComponent implements IDynamicElement, OnInit {
    config?: IHeroSlider;

    @Input() items: IHeroOld[] = [];

    ngOnInit(): void {
        if (this.config) {
            this.items = this.config.items;
        }
    }
}
